import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "flex flex-col gap-4 md:gap-6",
    cardWrapper: "flex overflow-x-scroll scroll-smooth snap-mandatory px-component-x-spacing-sm lg:px-0 snap-x gap-[2px]",
    heading: "text-heading-sm md:text-heading-md px-component-x-spacing-sm pl-4 md:pl-6 xl:pl-12",
    imageWrapper: "h-full p-4 relative object-cover lg:h-[70vh] lg:min-h-[448px] bg-background-surface-1 flex column flex-col justify-end group",
    media: "object-cover w-full h-full absolute top-0 left-0",
    item: "flex relative flex-col group lg:h-[70vh] lg:min-h-[448px] gap-2 flex-1 overflow-hidden snap-start",
    itemTitle: "text-heading-2xs text-white z-10",
    buttonWrapper: "group-hover:z-10"
  },
  variants: {
    darkenOthersOnHover: {
      true: {
        imageWrapper: "after:transition-[opacity] after:bg-black after:top-0 after:bottom-0 after:left-0 after:right-0 after:absolute data-[is-hovering=true]:after:opacity-40 data-[is-hovering=false]:after:opacity-0 data-[is-hovering=true]:after:!opacity-0 after:opacity-0"
      },
      false: {
        imageWrapper: ""
      }
    },
    layout: {
      growOnHover: {
        item: "flex-1 focus:flex-[1.5] hover:flex-[1.5] transition-[flex] ease-[cubic-bezier(.23,1,.32,1)] duration-[450ms] lg:aspect-[unset] lg:w-[unset] lg:min-w-[unset]"
      },
      slider: {
        item: "min-w-[70vw] aspect-[3/4] w-[70vw]"
      }
    },
    hasUnderlineAnimation: {
      true: {
        itemTitle: "after:content after:h-[1px] after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] group-hover:after:scale-x-100 after:w-full after:block"
      },
      false: {
        itemTitle: ""
      }
    }
  },
  defaultVariants: {
    hasUnderlineAnimation: "false",
    darkenOthersOnHover: "true",
    layout: { initial: "slider", lg: "growOnHover" }
  }
});
export {
  a as linksFluidImagesBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
